const LICENSE_STATUS = {
    "FULL_ACCESS" : "full_access", // 1
    "DORMANT" : "dormant",         // 2
    "VIEW_ONLY": "view_only",      // 0 
    "INACTIVE": "inactive"         // 3
};

export default LICENSE_STATUS;
